// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2TZHr","messages":"Chat_messages__3wHEo","dateDivider":"Chat_dateDivider__3NWC_"};